import React from 'react'
import styled from 'styled-components'
import { func } from 'prop-types'

import Wrapper from 'components/Wrapper'
import { H2, H4, fontWeights, lineHeights } from 'styles/typography'
import { white } from 'styles/colors'
import Section, { SectionBlock } from 'components/Section'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import SearchBox from './SearchBox'

const Container = styled(Section)`
  background-color: #15171e;
  text-align: center;
  margin-bottom: ${spacing.medium};

  ${media.medium`
    margin-bottom: ${spacing.large};
  `};
`

const Heading = styled(H2)`
  color: ${white};
`

const Alternate = styled(H4)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
`

const Search = ({ navigateTo }) => {
  return (
    <Container id="search">
      <Wrapper>
        <SectionBlock>
          <Heading>Any questions?</Heading>
        </SectionBlock>
        <SectionBlock>
          <SearchBox navigateTo={navigateTo} />
        </SectionBlock>
        <SectionBlock>
          <Alternate>Or you can also browse the topics below to find your answer</Alternate>
        </SectionBlock>
      </Wrapper>
    </Container>
  )
}

Search.propTypes = {
  navigateTo: func.isRequired
}

export default Search
